import Head from "next/head";
import Link from "next/link";

export default function What() {
	return (
		<>
			<Head>
				<title key="title">What | Lucien Smith - Seeds</title>
			</Head>
			<div className="mt-6 max-w-full">
				<h1 className="text-4xl text-center">
					<Link href="/">
						<a className="bland special-underline">SEEDS</a>
					</Link>
				</h1>
				<h1 className="text-xl text-center mt-14">What is a SEED?</h1>
				<div className="text-lg leading-7 mt-5">
					<p>
						SEEDS is a collection of NFTs created by{" "}
						<a href="https://luciensmithstudio.com" rel="noreferrer" target="_blank">
							Lucien Smith
						</a>{" "}
						to support <a href="https://stp.world/" rel="noreferrer" target="_blank">
							Serving the People
						</a>{" "} Foundation. The 10,000 unique tokens on the Ethereum-based blockchain serve as a direct way to support the foundation and act as membership which grants access to programming, events, merchandise drops and more. <a href="https://stp.world/" rel="noreferrer" target="_blank">
							Serving the People
						</a>{" "} aims to provide a platform to support emerging and independent artist.
					</p>
					<p className="mt-6">
						<a href="https://stp.world/" rel="noreferrer" target="_blank">
							Serving the People
						</a>{" "} is forever grateful for the support and resources provided by our partner{" "}
						<a href="https://lobus.io" rel="noreferrer" target="_blank">
							Lobus
						</a>{" "}
						. Together we understand what it takes to grow a healthier future.
					</p>

					<p className="mt-6">
						<a href="https://opensea.io/collection/seeds-luciensmith" rel="noreferrer" target="_blank">
							Click here
						</a> to view the existing SEEDS currently on the Ethereum Blockchain
					</p>
				</div>
				<div className="mt-6">
					<Link href="/rarity">
						<a className="mt-14">Still want to know more?</a>
					</Link>
				</div>
			</div>
		</>
	);
}
